import { useEffect, useState } from "react";

function daysInMonth(y, m) {
  return new Date(y, m + 1, 0).getDate();
}

export function BusyMonthGrid({ blocks, onDayClick }) {
  const [monthOffset, setMonthOffset] = useState(0);
  const now = new Date();
  const ref = new Date(now.getFullYear(), now.getMonth() + monthOffset, 1);
  const y = ref.getFullYear();
  const m = ref.getMonth();
  const total = daysInMonth(y, m);
  const firstWeekday = new Date(y, m, 1).getDay();

  // Build a set of "busy days" YYYY-MM-DD from blocks that intersect this month
  const busy = new Set();
  const monthStart = new Date(y, m, 1);
  const monthEnd = new Date(y, m + 1, 0, 23, 59, 59);
  (blocks || []).forEach((b) => {
    if (!b.start || !b.end) return;
    const s = new Date(b.start);
    const e = new Date(b.end);
    if (e < monthStart || s > monthEnd) return;
    const cursor = new Date(Math.max(s, monthStart));
    while (cursor <= e && cursor <= monthEnd) {
      const key = `${cursor.getFullYear()}-${cursor.getMonth()}-${cursor.getDate()}`;
      busy.add(key);
      cursor.setDate(cursor.getDate() + 1);
    }
  });

  const label = ref.toLocaleString("default", { month: "long", year: "numeric" });

  return (
    <div className="mt-10 border-t hairline pt-8" data-testid="busy-heatmap">
      <div className="flex items-center justify-between">
        <div>
          <div className="tick-label">Availability heatmap</div>
          <div className="font-display text-2xl font-bold mt-1">{label}</div>
        </div>
        <div className="flex gap-2">
          <button data-testid="heatmap-prev" onClick={() => setMonthOffset(monthOffset - 1)} className="btn-outline">←</button>
          <button data-testid="heatmap-next" onClick={() => setMonthOffset(monthOffset + 1)} className="btn-outline">→</button>
        </div>
      </div>

      <div className="mt-4 grid grid-cols-7 gap-1">
        {["S","M","T","W","T","F","S"].map((d, i) => (
          <div key={i} className="tick-label text-center py-1">{d}</div>
        ))}
        {Array.from({ length: firstWeekday }).map((_, i) => (<div key={`p${i}`} />))}
        {Array.from({ length: total }).map((_, i) => {
          const day = i + 1;
          const isBusy = busy.has(`${y}-${m}-${day}`);
          const isToday = day === now.getDate() && m === now.getMonth() && y === now.getFullYear();
          return (
            <button
              type="button"
              key={day}
              data-busy={isBusy}
              data-testid={`heatmap-day-${y}-${m + 1}-${day}`}
              disabled={isBusy}
              onClick={() => !isBusy && onDayClick && onDayClick(new Date(y, m, day, 10, 0))}
              className={`aspect-square border flex items-center justify-center font-mono text-sm transition-colors ${
                isBusy ? "bg-[#FF3B30]/25 border-[#FF3B30] text-white cursor-not-allowed" :
                isToday ? "border-[#FF3B30] text-[#FF3B30] hover:bg-[#FF3B30]/10 cursor-pointer" :
                "border-white/10 text-neutral-400 hover:border-[#FF3B30] hover:text-white cursor-pointer"
              }`}
            >{day}</button>
          );
        })}
      </div>
      <div className="mt-3 flex items-center gap-4 tick-label">
        <span className="flex items-center gap-1.5"><span className="inline-block w-3 h-3 bg-[#FF3B30]/25 border border-[#FF3B30]"></span> Busy</span>
        <span className="flex items-center gap-1.5"><span className="inline-block w-3 h-3 border border-white/10"></span> Open</span>
      </div>
    </div>
  );
}
